module.exports = __webpack_public_path__ + "img/view.da418f10.svg";